import { InputSideController, InputSideControllerEnable } from './InputSide/InputSideController';
import { InputNumberProps } from './type';
import { InputBase } from './InputBase';
import { Input } from './Input';
import { commify } from '../../../../shared/util/commify';
import { CustomEventWithDetail, on } from 'rune-ts';
import { InputFocusinEvent, InputFocusoutEvent } from './InputEvent';

export class InputNumberInputEvent extends CustomEventWithDetail<{ value?: number }> {}
export class InputNumberChangeEvent extends CustomEventWithDetail<{ value?: number }> {}

export class InputNumber extends InputBase<
  InputNumberProps,
  InputSideController<InputNumberProps>,
  InputSideControllerEnable<InputNumberProps>
> {
  private is_focus = false;

  constructor(data: InputNumberProps) {
    data.type = data.type ?? 'number';
    super(data, {
      InputSide: InputSideController,
      InputSideEnable: InputSideControllerEnable,
    });
    if (data.comma_seperated && data.value) {
      this.inputView.type = 'text';
      this.inputView.value = commify(data.value);
    }
  }

  getValue() {
    const { value } = this.data;
    return value;
  }

  setValue(value: number) {
    const { max, min } = this.data;
    this.data.value = max ? (max < value ? max : value) : min ? (min > value ? min : value) : value;
    this.inputView.setValue(this.data.value);
    this.dispatchEvent(InputNumberInputEvent, {
      bubbles: true,
      detail: {
        value: this.data.value,
      },
    });
  }

  reset() {
    this.inputView.reset();
    this.data.value = undefined;
  }

  override changeHandler(e: Event, input: Input) {
    if (!this.is_focus) return;

    const value = parseInt(input.getValue());

    if (isNaN(value)) {
      this.data.value = undefined;
    } else {
      this.setValue(value);
    }
  }

  @on(InputFocusoutEvent)
  focusoutHandler() {
    this.is_focus = false;
    if (this.data.comma_seperated) {
      this.inputView.type = 'text';
      this.inputView.redraw();
      this.inputView.setValue(commify(this.data.value));
    }
    this.dispatchEvent(InputNumberChangeEvent, {
      bubbles: true,
      detail: {
        value: this.data.value,
      },
    });
  }

  @on(InputFocusinEvent)
  focusinHandler() {
    if (this.data.comma_seperated) {
      this.inputView.type = 'number';
      this.inputView.redraw();
      this.inputView.setValue(this.data.value ?? '');
    }
    this.is_focus = true;
    this.dispatchEvent(InputNumberChangeEvent, {
      bubbles: true,
      detail: {
        value: this.data.value,
      },
    });
  }
}
